"use client"

import Sidebar from '@/components/Layout/Sidebar';
import Topbar from '@/components/Layout/Topbar';
// import type { Metadata } from "next";
import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { NextStepProvider, NextStep } from 'nextstepjs';


import useLocalStorage from '@/components/hooks/useLocalStorage';


import { usePathname } from 'next/navigation'

import { checkIsLoggedIn, getLoggedInUserName } from '@/utils/all_apis/authApi'


// import dynamic from 'next/dynamic';
// const Sidebar = dynamic(() => import('@/components/Layout/Sidebar'));


export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const pathname = usePathname()
  // const [collapsed, setCollapsed] = useLocalStorage("isCollapsed", false);
  // const [collapsed, setCollapsed] = useUrl();
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [isLoggedInAsGuest, setIsLoggedInAsGuest] = useState(true);
  // const [loading, setLoading] = useState(true);
  const router = useRouter();
  // const [isSidebarOpen, setIsSidebarOpen] = useLocalStorage('isSidebarOpen', true); // Default state
  const [collapsed, setCollapsed] = useLocalStorage("isCollapsed", false);
  const [isLoading, setIsLoading] = useState(true);
  const [username, setUsername] = useState("")

  useEffect(() => {
    // Wait until the sidebar state is initialized
    if (collapsed !== undefined) {
      setIsLoading(false);
    }
  }, [collapsed]);

  useEffect(() => {
    // Check if localStorage is available
    (async () => {
      if (typeof window !== "undefined") {
        const isLoggedInAsGuest = localStorage.getItem('isLoggedInAsGuest') === 'true';
        setIsLoggedInAsGuest(isLoggedInAsGuest)

        const loggedIn = await checkIsLoggedIn();
        setIsLoggedIn(loggedIn);

        if (!loggedIn && !isLoggedInAsGuest) {
          router.push('/login'); // Redirect to login page if not logged in
          return;
        }

        const usernameData = await getLoggedInUserName()
        setUsername(usernameData)
        
      }
    })();
    // setLoading(false);
  }, [router]);

  const steps:any = [
    {
      tour: "mainTour",
      steps: [
        {
          icon: "👋",
          title: "Welcome",
          content: "Let's get started with InfraQ!",
          // selector: "#step1",
          // side: "right",
          showControls: true,
          showSkip: true
        },
        {
          // icon: "👋",
          title: "Settings Page",
          content: "Click Settings page to create a Project Form",
          selector: "#guidesettings",
          side: "right",
          showControls: true,
          showSkip: true,
          nextRoute: pathname=='/settings'?undefined:'/settings'
        },
        {
          // icon: "👋",
          title: "Project Form",
          content: "Create a Project Form here",
          selector: "#guideprojectform",
          side: "right",
          showControls: true,
          showSkip: true,
          nextRoute: pathname=='/form-template/project'?undefined:'/form-template/project'
        },
        {
          // icon: "👋",
          title: "Fill Form",
          content: "Fill form",
          selector: "#guidefillprojectform",
          side: "right",
          showControls: true,
          showSkip: true,
          // pointerPadding:20,
          nextRoute: pathname=='/form-template/project'?undefined:'/form-template/project',
          prevRoute: pathname=='/settings'?undefined:'/settings'
        },
        {
          // icon: "👋",
          title: "Submit Form",
          content: "Submit here",
          selector: "#guidesubmitprojectform",
          side: "left-top",
          showControls: true,
          showSkip: true,
          nextRoute: pathname=='/forms-list'||pathname==''?undefined:'/forms-list'
        },
        {
          // icon: "👋",
          title: "View All Submitted Forms",
          content: "View forms here",
          // selector: "#guideallforms",
          // side: "right",
          showControls: true,
          showSkip: true,
          prevRoute: pathname=='/form-template/project'?undefined:'/form-template/project',
          // pointerPadding:20,
          
        },
        // More steps...
      ]
    }
  ];
  
  

  // if (loading) {
  //   return <div>Loading...</div>; // Show loading message
  // }

  if (isLoading) return null;
  if (!(isLoggedIn || isLoggedInAsGuest)) return null;

  return (
      <>
      <NextStepProvider>
      <NextStep steps={steps} cardTransition={{ duration: 0 }}>
          <Sidebar key={"sidebarrefreshkey_0"} setCollapsed={setCollapsed} collapsed={collapsed} />
          <div className="flex flex-col flex-grow"> {/* Adjusted for sidebar width */}
            <Topbar collapsed={collapsed} isLoggedInAsGuest={isLoggedInAsGuest} username={username} />
            {/* Make sure to add a margin-top to avoid content being hidden behind the top bar */}
            <main className={`ml-0 flex-grow mt-[48px] overflow-y-auto bg-white min-h-[calc(100vh-48px)] transition-all duration-300 ${collapsed ? 'md:ml-10' : 'md:ml-[200px]'}`}>{children}</main> {/* Adjusted for top bar height */}
          </div>
        </NextStep>
        </NextStepProvider>
      </>
  );
}
